import de_DE from './de-DE';
import en_GB from './en-GB';
import nl_NL from './nl-NL';
import fr_FR from './fr-FR';

export type MessageSchema = Partial<typeof en_GB>;

export default {
	'de-DE': de_DE,
	'en-GB': en_GB,
	'nl-NL': nl_NL,
	'fr-FR': fr_FR,
};
